import { apiService } from "../store";
import moment from "moment";
import { messageError, scheduleRequestNoLoading } from "./index";

export const scheduleTrainer = (schedule) => {
  return {
    type: "SCHEDULE_TRAINER",
    payload: schedule,
  };
};
export const trainingLoaded = (training) => {
  return {
    type: "TRAINING_LOADED",
    payload: training,
  };
};
export const loadingMain = (boolean) => {
  return {
    type: "MAIN_LOADING",
    payload: boolean,
  };
};
export const loadingTraining = (boolean) => {
  return {
    type: "TRAINING_LOADING",
    payload: boolean,
  };
};
export const loadingStatus = (boolean) => {
  return {
    type: "STATUS_LOADING",
    payload: boolean,
  };
};
export const statusTrainingChildren = (data) => {
  return {
    type: "STATUS_TRAINING_CHILDREN",
    payload: data,
  };
};

export const getScheduleTrainer = (trainer_id) => (dispatch) => {
  dispatch(loadingMain(true));
  const schedule = {
    start: moment(new Date()).subtract(1, "days").format("YYYY-MM-DD"),
    end: moment(new Date()).add(1, "months").format("YYYY-MM-DD"),
    trainer_id: trainer_id,
  };
  apiService
    .getCalendarTrainerRequest(schedule)
    .then((data) => {
      dispatch(scheduleTrainer(data));
      dispatch(loadingMain(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const loadedTraining = (id) => (dispatch) => {
  dispatch(loadingTraining(true));
  apiService
    .getChildrenRequest(id)
    .then((data) => {
      dispatch(trainingLoaded(data));
      dispatch(loadingTraining(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const loadedTrainingChanges = (id) => (dispatch) => {
  dispatch(loadingStatus(true));
  apiService
    .getChildrenRequest(id)
    .then((data) => {
      dispatch(trainingLoaded(data));
      dispatch(loadingStatus(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const stateTrainingChildren = () => (dispatch) => {
  apiService
    .stateTrainingChildren()
    .then((data) => {
      dispatch(statusTrainingChildren(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const updateStateChildTraining =
  (id, schedule_id, payload) => (dispatch) => {
    apiService
      .updateStateChildrenTraining(id, payload)
      .then(() => {
        dispatch(loadedTrainingChanges(schedule_id));
      })
      .catch((err) => {
        dispatch(messageError(err.response.data.message));
      });
  };
export const scheduleUpdate = (id, payload) => (dispatch) => {
  apiService
    .updateSchedule(id, payload)
    .then(() => {
      dispatch(loadedTraining(id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const addEventTraining = (required, payload) => (dispatch) => {
  apiService
    .createHistory(required, payload)
    .then(() => {
      dispatch(loadedTrainingChanges(payload.id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const addEventSchedule = (required, payload) => (dispatch) => {
  apiService
    .createHistory(required, payload)
    .then(() => {
      dispatch(scheduleRequestNoLoading(payload.id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
